import { useState } from "react";
import axios from "axios";
import { API } from "@/contexts/AuthContext";

export default function WebsiteDomainRenewal({ hostname, locked, run }) {
  const [info, setInfo] = useState(null);
  const [notice, setNotice] = useState("");
  const load = () => run("domain-expiry", async () => {
    const { data } = await axios.get(
      API + "/website-builder/publications/hosting/" + encodeURIComponent(hostname) + "/renewal",
    );
    setInfo(data); setNotice("");
  });
  const request = () => {
    if (locked || !info) return;
    if (!window.confirm("Request a review of a one-year renewal for " + info.domain +
      "? This request does not renew the domain or approve a payment. Price and approval follow separately.")) return;
    return run("renewal-request", async () => {
      const { data } = await axios.post(
        API + "/website-builder/publications/hosting/" + encodeURIComponent(hostname) + "/renewal-request",
        { expected_expiry: info.expires_on, years: 1, confirm_request: true },
      );
      setInfo((current) => ({ ...current, recent_requests: [
        data, ...current.recent_requests.filter((item) => item.id !== data.id),
      ].slice(0, 10) }));
      setNotice("Renewal review request recorded. No domain renewal or payment has been executed.");
    });
  };
  const labels = {
    awaiting_review: "Awaiting review", approved: "Approved; not yet processed",
    processing: "Processing", renewed: "Renewal confirmed", review_required: "Review required",
    refused: "Not approved", failed: "Renewal not confirmed",
  };
  return <section className="space-y-2 border-t pt-3" aria-label="Domain renewal">
    <h4 className="text-sm font-medium">Domain expiry and renewal</h4>
    <button type="button" disabled={locked} onClick={load}
      className="rounded border px-3 py-2 text-sm disabled:opacity-50">Read expiry and renewal status</button>
    {notice && <p role="status" className="text-sm text-emerald-700">{notice}</p>}
    {info && <div className="space-y-2 text-xs">
      <p>{info.domain} · Registrar expiry date: {info.expires_on}</p>
      {info.premium && <p className="text-amber-700">Premium domain: renewal pricing requires a separate review.</p>}
      <button type="button" disabled={locked} onClick={request}
        className="rounded border px-3 py-2 text-sm disabled:opacity-50">Request one-year renewal review</button>
      <p className="text-slate-500">A review request does not authorize a charge. Renewal needs separate price, approval and funding confirmation.</p>
      {info.recent_requests.length > 0 && <ul className="space-y-1">
        {info.recent_requests.map((item) => <li key={item.id}>
          {new Date(item.created_at).toLocaleString()} · {labels[item.state] || "Status needs review"}
        </li>)}
      </ul>}
    </div>}
  </section>;
}
